import T from 'i18n-react'
import { createSelector } from 'reselect'

import {
  invalidCategorySelector as invalidSelector
} from 'containers/Form/Validation/selectors'
import {
  categoryElementsSelector
} from 'containers/Form/Project/selectors'
import {
  formattedCategoriesSelector as categorySelector
} from 'containers/Form/selectors'
import { categoryOrder, elementOrder } from 'containers/Form/Project/constants'

const projectDetailsSelector = state => state.projectOverview

export const projectIdSelector = createSelector(
  projectDetailsSelector,
  (details) => details.projectId
)

export const brandSelector = createSelector(
  projectDetailsSelector,
  (details) => details.brand
)

export const partnerSiteNameSelector = createSelector(
  projectDetailsSelector,
  (details) => details.partnerSiteName
)

export const productSkuSelector = createSelector(
  projectDetailsSelector,
  (details) => details.sku
)

export const gpuSkuSelector = createSelector(
  projectDetailsSelector,
  (details) => details.gpuSku
)

export const workflowIdSelector = createSelector(
  projectDetailsSelector,
  (details) => details.workflowId
)

export const segmentSelector = createSelector(
  projectDetailsSelector,
  (details) => details.segment
)

const formElementSelector = (state) => state.projectOverview.elements

export const formattedCategoriesSelector = createSelector(
  categoryElementsSelector,
  (categories) => categories.map(({category}) => ({key: category,  label: category }))
)
 
export const invalidCategorySelector = invalidSelector(categoryElementsSelector)
